const doc = [({"en":({"js":({"admin":({"logs":({"names":({"activity_participant":({"no_activity_participant":"No participant"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;